var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import IconFiscalNote from '@/components/Icons/IconFiscalNote.vue';
import IconDocument from '@/components/Icons/IconDocument.vue';
import IconBoleto from '@/components/Icons/IconBoleto.vue';
import IconArrowDown from '@/components/Icons/IconArrowDown.vue';
import { getDateByFormat, formatCurrency } from '@/shared/utils/helpers';
import LoadingDots from '@/components/LoadingDots.vue';
import Tooltip from '@/components/Tooltip.vue';
import IconRefresh from '@/components/Icons/IconRefresh.vue';
import { listPayments } from '@/clients/payment';
import DateRangePicker from '@/components/DateRangePicker.vue';
import Pagination from '@/components/Pagination.vue';
let AccountInformationList = class AccountInformationList extends Vue {
    constructor() {
        super(...arguments);
        this.paymentList = [];
        this.filterTypes = ['Item', 'Total', 'Data venc.', 'Status'];
        this.currentMonth = 'Todo o período';
        this.currentFilter = 'Data venc.';
        this.filterDirection = 'down';
        this.loadingList = true;
        this.pageError = false;
        this.periodFilter = {
            startDate: '',
            endDate: '',
        };
        this.currentPage = 1;
        this.perPage = 10;
        this.hasMore = true;
        this.dateRangeFilter = null;
        this.fiscalNoteStatus = {
            cancelled: 'Essa nota fiscal foi cancelada',
            pending: 'Aguardando nota fiscal',
        };
        this.today = new Date();
        this.paymentType = {
            waiting: 'Em aberto',
            approved: 'Pago',
            cancelled: 'Cancelado',
            fail: 'Falhou',
        };
        this.customNamesForPlans = {
            'Usuários permitidos': 'Compra - Usuário Adicional',
            'app_speed_mail - percent - SpeedMail': 'Aplicativo: SpeedMail',
        };
        this.filterByExpiration = arr => arr.filter(({ expiration_date }) => new Date(expiration_date.replace(/-/g, '/')) > this.today);
    }
    async mounted() {
        await this.fetchPaymentList();
    }
    changeDateRangeFilter(value) {
        if (!value)
            return;
        this.currentPage = 1;
        this.paymentList = [];
        this.periodFilter = {
            startDate: value[0].toISOString(),
            endDate: value[1].toISOString(),
        };
        this.closeDropdownDatePicker();
        this.fetchPaymentList();
    }
    closeDropdownDatePicker() {
        // @ts-ignore
        this.$refs.dropdownMenu.hide();
    }
    formatPrice(val) {
        return formatCurrency(val);
    }
    listSorting(comparativeA, comparativeB) {
        const op = this.filterDirection == 'down' ? '<' : '>';
        const list = [...this.changeMonthFilter(this.currentMonth)];
        const arr = list.sort((a, b) => eval(comparativeA + op + comparativeB) ? 1 : -1);
        return arr;
    }
    changeFilter(item) {
        if (this.currentFilter !== item) {
            this.filterDirection = 'down';
            this.currentFilter = item;
        }
        else {
            this.filterDirection = this.filterDirection == 'down' ? 'up' : 'down';
        }
    }
    getDate(date) {
        const new_date = date.includes('T') ? date.split('T') : date.split(' ');
        return getDateByFormat(new_date[0], 'DD MMMM YYYY');
    }
    getDateMonthAndYear(date) {
        const new_date = date.includes('T') ? date.split('T') : date.split(' ');
        return getDateByFormat(new_date[0], 'MMMM YYYY');
    }
    addListTitle(callList) {
        callList.forEach((el, index) => {
            callList[index]['tittle'] =
                el.items.filter(e => e.name === 'Mensalidade').length > 0
                    ? `Plano Atual - ${this.getDateMonthAndYear(el.expiration_date)}`
                    : this.customNamesForPlans[el.items[0].name] || el.items[0].name;
        });
        return callList;
    }
    async fetchPaymentList() {
        this.loadingList = true;
        try {
            const response = await listPayments({
                startDate: this.periodFilter.startDate,
                endDate: this.periodFilter.endDate,
                page: this.currentPage,
                perPage: this.perPage,
            });
            const callList = (response.data || []);
            this.paymentList = this.addListTitle(callList);
            if (callList.length >= this.perPage) {
                this.hasMore = true;
            }
            else {
                this.hasMore = false;
            }
        }
        catch (e) {
            this.pageError = true;
        }
        this.loadingList = false;
    }
    openBankSlipBarCode(url) {
        window.open(url, '_blank');
    }
    fiscalNoteText(status) {
        return this.fiscalNoteStatus[status];
    }
    openCreditCardFiscalNote(item) {
        if (item && item.url)
            window.open(item.url, '_blank');
    }
    handleScroll(event) {
        const target = event.target;
        const { scrollTop, scrollHeight, clientHeight } = target;
        // Checa se o usuário rolou até o final (margem de 50px)
        const isNearEnd = scrollTop + clientHeight >= scrollHeight - 50;
        if (isNearEnd && !this.loadingList && this.hasMore) {
            this.fetchPaymentList();
        }
    }
    setPageNumber(page) {
        this.currentPage = page;
        this.fetchPaymentList();
    }
    changeMonthFilter(val) {
        const filter = [
            ...this.paymentList.filter(a => getDateByFormat(a.expiration_date, 'MMMM') == val),
        ];
        if (!val || val == 'Todo o período') {
            return this.paymentList;
        }
        else {
            return filter;
        }
    }
    get FilterByDate() {
        return this.listSorting('new Date(a.expiration_date)', 'new Date(b.expiration_date)');
    }
    get FilterByPrice() {
        return this.listSorting('a.total_price', 'b.total_price');
    }
    get FilterByTittle() {
        return this.listSorting('b.tittle', 'a.tittle');
    }
    get FilterByStatus() {
        return this.listSorting('b.status', 'a.status');
    }
    get paymentListSortedByHeader() {
        switch (this.currentFilter) {
            case 'Data venc.':
                return this.FilterByDate;
            case 'Total':
                return this.FilterByPrice;
            case 'Item':
                return this.FilterByTittle;
            case 'Status':
                return this.FilterByStatus;
        }
        return this.changeMonthFilter(this.currentMonth);
    }
};
__decorate([
    Watch('currentMonth')
], AccountInformationList.prototype, "changeMonthFilter", null);
AccountInformationList = __decorate([
    Component({
        components: {
            IconFiscalNote,
            IconDocument,
            IconBoleto,
            IconArrowDown,
            LoadingDots,
            IconRefresh,
            Tooltip,
            DateRangePicker,
            Pagination,
        },
    })
], AccountInformationList);
export default AccountInformationList;
